import { Link } from "react-router-dom";
import { siteStats } from "@/mocks/clueData";

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20background%20made%20of%20layered%20warm%20terracotta%20and%20golden%20amber%20paper%20shapes%20with%20subtle%20grid%20lines%2C%20scattered%20speech%20bubble%20outlines%20and%20soft%20grain%20texture%2C%20flat%20vector%20art%20on%20cream%20base%2C%20no%20text%2C%20balanced%20composition%20for%20overlay&width=1600&height=900&seq=news-hero-bg-01&orientation=landscape"
          alt="17.cc 网友爆料站首屏抽象背景插画"
          className="h-full w-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/75"></div>

      <div className="relative mx-auto flex w-full flex-col items-center px-4 py-20 text-center md:px-8 md:py-28">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur">
          <i className="ri-shield-check-line text-sm"></i>
          真实见闻 · 隐私优先 · 理性阅读
        </span>

        <h1 className="mt-6 font-heading text-3xl font-bold leading-tight tracking-tight text-background-50 md:text-5xl">
          17.cc 网友爆料站
          <span className="mt-3 block text-xl font-semibold text-background-100 md:text-3xl">
            网友爆料 · 投稿吃瓜 · 线索征集
          </span>
        </h1>

        <p className="mt-6 max-w-2xl text-sm leading-7 text-background-100/90 md:text-base">
          如果你有想讲述的真实经历、想分享的城市见闻，或希望被更多人看见的线索，
          这里提供匿名爆料与用户投稿的入口。我们把信息整理清楚，再交给你判断。
        </p>

        <div className="mt-8 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/submit"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-send-plane-line text-base"></i>
            我要匿名爆料
          </Link>
          <Link
            to="/clues"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20 sm:w-auto"
          >
            <i className="ri-fire-line text-base"></i>
            浏览热门爆料
          </Link>
        </div>

        <dl className="mt-14 grid w-full max-w-3xl grid-cols-2 gap-4 md:grid-cols-4">
          {siteStats.map((stat) => (
            <div
              key={stat.label}
              className="flex flex-col-reverse rounded-lg border border-background-50/20 bg-background-50/10 px-4 py-4 backdrop-blur"
            >
              <dt className="mt-1 text-xs text-background-100/85">{stat.label}</dt>
              <dd className="font-heading text-xl font-bold text-background-50 md:text-2xl">
                {stat.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}